import Vue from "vue";
import VeeValidate from "vee-validate";
import {localization} from "@/common/lang/localization";

import "./validators";

const i18n = localization.i18n;

Vue.use(VeeValidate, {
    i18nRootKey: "common.validation",
    i18n,
});